module.exports = __webpack_public_path__ + "static/media/Dubai-Outlet-Mall.9c542951.jpg";